import { InMemoryCache } from "@apollo/client";

export const cache = new InMemoryCache({
  typePolicies: {
    Query: {
      fields: {
        getNlpConversations: {
          keyArgs: ["user_id", "session_id"],
          merge(existing, incoming, { args }) {
            if (!incoming?.conversations) return incoming ?? existing;
            const offset = args?.offset ?? 0;
            if (offset === 0) return incoming;
            const prev = existing?.conversations ?? [];
            return {
              conversations: [...prev, ...(incoming.conversations ?? [])],
              hasMore: incoming.hasMore ?? false,
            };
          },
        },
      },
    },
  },
});
